import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';

export const useUserValidationSchema = (phonePatterns = {}) => {
  const { t } = useTranslation();

  return Yup.object({
    name: Yup.string()
      .min(2, t('pages.register.nameTooShort'))
      .matches(/^[a-zA-Z\sñÑáéíóúÁÉÍÓÚüÜ]*$/, t('pages.register.invalidName'))
      .matches(/^[^<>]*$/, t('pages.register.invalidCharactersName'))
      .required(t('pages.register.nameRequired')),
    surnames: Yup.string()
      .min(2, t('pages.register.surnamesTooShort'))
      .matches(
        /^[a-zA-Z\sñÑáéíóúÁÉÍÓÚüÜ]*$/,
        t('pages.register.invalidSurnames')
      )
      .matches(/^[^<>]*$/, t('pages.register.invalidCharactersSurnames'))
      .required(t('pages.register.surnamesRequired')),
    phone: Yup.string()
      .trim()
      .required(t('pages.register.phoneRequired'))
      .test(
        'phone-prefix',
        t('pages.register.phoneInvalidForPrefix'),
        function (value) {
          const { prefix } = this.parent;
          const pattern = phonePatterns[prefix];
          if (!pattern) return true;
          return pattern.test(value);
        }
      ),
    birth_date: Yup.date()
      .nullable()
      .max(new Date(), t('pages.register.birthDateInvalid'))
      .typeError(t('pages.register.birthDateInvalid'))
      .required(t('pages.patients.formValidation.invalidDate'))
      .test(
        'is-adult',
        t('pages.register.birthDateNotAdult'), // Traducción: "Debes ser mayor de edad"
        function (value) {
          if (!value) return false;
          const today = new Date();
          const adultDate = new Date(
            today.getFullYear() - 18,
            today.getMonth(),
            today.getDate()
          );
          return value <= adultDate;
        }
      ),
    email: Yup.string()
      .email(t('pages.register.emailInvalid'))
      .matches(
        /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
        t('pages.register.emailInvalid')
      )
      .matches(/^[^<>]*$/, t('pages.login.invalidCharacters'))
      .required(t('pages.register.emailRequired')),
    password: Yup.string()
      .min(8, t('pages.register.passwordMin'))
      .max(20, t('pages.register.passwordMax'))
      .matches(/[a-z]/, t('pages.register.passwordLowercase'))
      .matches(/[A-Z]/, t('pages.register.passwordUppercase'))
      .matches(/[0-9]/, t('pages.register.passwordNumber'))
      .matches(/[\W_]/, t('pages.register.passwordSpecial'))
      .notOneOf(
        ['password', '12345678', 'abc123'],
        t('pages.register.passwordNotCommon')
      )
      .required(t('pages.register.passwordRequired')),
    organization_id: Yup.string().required(
      t('pages.register.organizationRequired')
    ),
    nationality: Yup.string()
      .matches(/^[a-zA-Z\sñÑ]*$/, t('pages.register.invalidNationality'))
      .required(t('pages.register.nationalityRequired')),
    prefix: Yup.string().required(),
  });
};
